import { useNavigate } from 'react-router-dom';
import { BottomRightVector, ContentWrapper, Header, Illustration, ReloadButton, TopLeftVector } from './Error.styled';
import { HOME_ROUTE } from 'constants/routes';

export const Error = () => {
    const navigate = useNavigate();

    const goToHome = () => {
        navigate(HOME_ROUTE);
    };

    return (
        <ContentWrapper>
            <TopLeftVector />
            <BottomRightVector />
            <Illustration />
            <Header textWeight="Medium">Ouch! Something went wrong.</Header>
            <ReloadButton onClick={goToHome}>Go to Home</ReloadButton>
        </ContentWrapper>
    );
};
